"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Configurator = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Configurator, _React$Component);
  var _super = _createSuper(Configurator);
  function Configurator(props, context) {
    var _this;
    (0, _classCallCheck2["default"])(this, Configurator);
    _this = _super.call(this, props, context);
    props.actions.clearState();
    if (!props.settings.isDelayedLaunch) {
      props.actions.loadOptions(props.selections);
    }
    return _this;
  }
  (0, _createClass2["default"])(Configurator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        settings = _this$props.settings;
      if (!settings.isDelayedLaunch) {
        var optionIds = this.props.optionIds;
        if (optionIds && optionIds.length) {
          return children;
        }
        return null;
      }
      return children;
    }
  }]);
  return Configurator;
}(_react["default"].Component);
Configurator.propTypes = {
  optionIds: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  actions: _propTypes["default"].object.isRequired,
  selections: _propTypes["default"].arrayOf(_propTypes["default"].object),
  children: _propTypes["default"].node.isRequired,
  settings: _propTypes["default"].shape({
    isDelayedLaunch: _propTypes["default"].bool
  })
};
Configurator.defaultProps = {
  selections: [],
  settings: {}
};
var _default = exports["default"] = Configurator;
//# sourceMappingURL=Configurator.js.map